/*
  Dawn's <slider-component> (used to wrap product grids that scroll/swipe,
  e.g. the "Most Wanted" featured-collection carousel) treats any pointerdown
  followed by >3px of pointer movement before pointerup as a drag, and its
  click listener (registered with useCapture: true on the slider element)
  responds by calling stopPropagation() on the resulting click — so the
  click never reaches descendants. That's correct for the product image/link
  (you don't want a swipe to also navigate), but it also swallows real clicks
  on the Quick View button sitting inside the same slider, since almost any
  human (or automated) click involves a few pixels of movement between
  press and release.

  Fix: stop the pointerdown from ever reaching the slider's own pointerdown
  handler (which is what flags the gesture as a drag in the first place).
  Listening on `document` with capture: true runs before the slider's own
  (non-capturing) pointerdown listener can fire, so calling stopPropagation()
  here prevents that handler from ever seeing the event — the slider's drag
  state is simply never engaged for gestures starting on this button. This
  only affects the pointerdown event; the later click event is untouched and
  reaches the button's own listener normally.
*/
document.addEventListener(
  'pointerdown',
  function (event) {
    if (event.target.closest('.quick-view-button')) {
      event.stopPropagation();
    }
  },
  true
);
